(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sf-article-promo"] && !Shopify.designMode) return;
  try {
    class SfArticleNewsletter extends HTMLElement {
  #abortController = null;
  #hideTimer       = null;
  #onSubmit = (event) => this.#handleSubmit(event);

  connectedCallback() {
    this.querySelector('form')?.addEventListener('submit', this.#onSubmit);
  }

  disconnectedCallback() {
    this.querySelector('form')?.removeEventListener('submit', this.#onSubmit);
    this.#abortController?.abort();
    clearTimeout(this.#hideTimer);
  }

  #hideAfter(element, ms) {
    clearTimeout(this.#hideTimer);
    this.#hideTimer = setTimeout(() => { element.hidden = true; }, ms);
  }

  get #nameInput()      { return this.querySelector('[ref="nameInput"]'); }
  get #emailInput()     { return this.querySelector('[ref="emailInput"]'); }
  get #submitBtn()      { return this.querySelector('[ref="submitBtn"]'); }
  get #errorMessage()   { return this.querySelector('[ref="errorMessage"]'); }
  get #successMessage() { return this.querySelector('[ref="successMessage"]'); }

  async #handleSubmit(event) {
    event.preventDefault();

    const email     = this.#emailInput?.value.trim();
    const firstName = this.#nameInput?.value.trim();
    const companyId = this.dataset.companyId;
    const listId    = this.dataset.listId;

    if (!email || !companyId || !listId) return;

    this.#abortController?.abort();
    this.#abortController = new AbortController();

    this.#submitBtn.disabled    = true;
    this.#errorMessage.hidden   = true;
    this.#successMessage.hidden = true;

    const profileAttributes = { email };
    if (firstName) profileAttributes.first_name = firstName;

    try {
      const response = await fetch(
        `https://a.klaviyo.com/client/subscriptions/?company_id=${companyId}`,
        {
          method: 'POST',
          signal: this.#abortController.signal,
          headers: {
            'content-type': 'application/json',
            'revision': '2024-10-15'
          },
          body: JSON.stringify({
            data: {
              type: 'subscription',
              attributes: {
                custom_source: 'Article newsletter',
                profile: {
                  data: {
                    type: 'profile',
                    attributes: profileAttributes
                  }
                }
              },
              relationships: {
                list: {
                  data: { type: 'list', id: listId }
                }
              }
            }
          })
        }
      );

      if (response.ok) {
        this.#successMessage.hidden = false;
        this.#hideAfter(this.#successMessage, 5000);
        this.#emailInput.value = '';
        if (this.#nameInput) this.#nameInput.value = '';
      } else {
        this.#errorMessage.hidden = false;
        this.#hideAfter(this.#errorMessage, 5000);
      }
    } catch (error) {
      if (error.name !== 'AbortError') {
        this.#errorMessage.hidden = false;
        this.#hideAfter(this.#errorMessage, 5000);
      }
    } finally {
      this.#submitBtn.disabled = false;
    }
  }
}

if (!customElements.get('sf-article-newsletter')) {
  customElements.define('sf-article-newsletter', SfArticleNewsletter);
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["variant-main-picker"] && !Shopify.designMode) return;
  try {
    /* Close custom dropdown on selection + update trigger */
  document.addEventListener('change', (event) => {
    const input = event.target;
    const dropdown = input.closest('.variant-dropdown');
    if (!dropdown) return;

    const details = dropdown;
    const triggerText = details.querySelector('.variant-dropdown__trigger-text');
    const triggerSwatch = details.querySelector('.variant-dropdown__trigger .swatch');
    const legend = dropdown.closest('.variant-option--custom-dropdown')?.querySelector('.variant-option__dropdown-value');

    const trigger = details.querySelector('.variant-dropdown__trigger');
    const selectedOption = input.closest('.variant-dropdown__option');

    /* Update trigger text */
    if (triggerText) {
      triggerText.textContent = input.value;
    }

    /* Update legend value */
    if (legend) {
      legend.textContent = input.value;
    }

    /* Update trigger data-value-handle for ::before icon */
    if (trigger && selectedOption) {
      trigger.dataset.valueHandle = selectedOption.dataset.valueHandle;
    }

    /* Close the dropdown */
    details.removeAttribute('open');
  });

  /* Close dropdown when clicking outside */
  document.addEventListener('click', (event) => {
    document.querySelectorAll('.variant-dropdown[open]').forEach((details) => {
      if (!details.contains(event.target)) {
        details.removeAttribute('open');
      }
    });
  });
  } catch(e) { console.error(e); }
})();

})();
